import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { JabraVideoDirective } from './jabra-video.directive';
export var JabraVideoComponentNgModule = module(baseModuleId + ".jabra-video", [])
    .directive('jabraVideo', JabraVideoDirective);
